import { useSelector } from "react-redux";


const WorldCupMoment = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
    // console.log(OrgId, 'org_id__________')

    return (
        <>
        {/* <h4 style={{"text-align": "center","padding-bottom": "20px"}}>HAPPI CARE</h4> */}
        <div className="iframe-div">
        
<iframe title="Report Section" width="600" height="373.5" src="https://iiplwork.retool.com/embedded/public/757f7e71-d392-424c-8655-4a0909b8a470" frameborder="0" allowFullScreen="true"></iframe>
        </div>
        </>
        
    )
};

export default WorldCupMoment;